var moduleMap = {
	"./onboardindfunds": () => {
		return Promise.all([__webpack_require__.e(1269), __webpack_require__.e(4884), __webpack_require__.e(1477), __webpack_require__.e(7170), __webpack_require__.e(2284), __webpack_require__.e(7994), __webpack_require__.e(7996), __webpack_require__.e(2462), __webpack_require__.e(6904)]).then(() => (() => ((__webpack_require__(86904)))));
	},
	"./onboardingpipeline": () => {
		return Promise.all([__webpack_require__.e(1269), __webpack_require__.e(4884), __webpack_require__.e(1477), __webpack_require__.e(7170), __webpack_require__.e(2284), __webpack_require__.e(7994), __webpack_require__.e(7996), __webpack_require__.e(2462), __webpack_require__.e(3585)]).then(() => (() => ((__webpack_require__(13585)))));
	},
	"./onboardingflow": () => {
		return Promise.all([__webpack_require__.e(1269), __webpack_require__.e(4884), __webpack_require__.e(1477), __webpack_require__.e(7170), __webpack_require__.e(2284), __webpack_require__.e(7994), __webpack_require__.e(7996), __webpack_require__.e(2462), __webpack_require__.e(3664)]).then(() => (() => ((__webpack_require__(63664)))));
	},
	"./onboardingsession": () => {
		return Promise.all([__webpack_require__.e(1269), __webpack_require__.e(4884), __webpack_require__.e(1477), __webpack_require__.e(7170), __webpack_require__.e(2284), __webpack_require__.e(7994), __webpack_require__.e(7996), __webpack_require__.e(2462), __webpack_require__.e(407)]).then(() => (() => ((__webpack_require__(40407)))));
	},
	"./onboardingfunddetails": () => {
		return Promise.all([__webpack_require__.e(1269), __webpack_require__.e(4884), __webpack_require__.e(1477), __webpack_require__.e(7170), __webpack_require__.e(2284), __webpack_require__.e(7994), __webpack_require__.e(7996), __webpack_require__.e(2462), __webpack_require__.e(3825)]).then(() => (() => ((__webpack_require__(3825)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var oldScope = __webpack_require__.S["default"];
	var name = "default"
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});